/*
* 选择优惠券页面
*/
import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
// import { COURSE_URL } from "../../constants";
import AXIOS from '../../api/axios';
import UA from '../../utils/ua';
import { apiDefine } from '../../api/web';
import { parseDate } from '../../utils/tools';
import Load from '../../template/Load/Load';

import './DiscountCouponPage.less';

class DiscountCoupon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            couponId: '', // 所选优惠券
            isMobile: UA.mobileClient,
            completeRender: false, // 是否loading
            discountList: [], // 优惠券列表
        };
    }

    sendNotificationToH5 = (res) => {
        const { notification } = JSON.parse(res);
        if(notification === 'aboutToClose'){
            localStorage.removeItem('no_use_discount')
            localStorage.removeItem('user_discount') // 清除，下次进入则重新接口获取
        }
    }

    componentWillMount() {
        // 保存是否勾选协议
        let isAllowAgreement = this.props.location.state.isAllowAgreement;
        if(isAllowAgreement) {
            localStorage.setItem('is_allow_agreement', isAllowAgreement)
        }
        localStorage.setItem('no_use_discount', this.props.location.state.notUseDiscount )
        let discountCoupon = this.props.location.state.discountCoupon;
        if(!!discountCoupon && Object.keys(discountCoupon).length > 0) {
            localStorage.setItem('user_discount', JSON.stringify(this.props.location.state.discountCoupon) )
        }
        this.setState({
            couponId: this.props.location.state.couponId,
            // source: this.props.location.state.source
        })
        // 获取该课程可用优惠券列表
        this.GetDiscountList(this.props.location.state.goodsId)
        apiDefine({ apiName:'sendNotificationToH5', fn: this.sendNotificationToH5 }); // 定义客户端关闭按钮
    }

    // 获取该课程可用优惠券列表
    GetDiscountList = (goodsId) => {
        AXIOS.getDiscountList({ data: { goodsId } }, (res, err) => {
            if( err ){
                alert(err.errorMessage);
                return;
            }
            this.setState({
                discountList: res || [],
                completeRender: true
            })
        })
    }

    // 退回上一页
    handleBack = () => {
        window.history.back();
    }

    // 选择优惠券
    selectDiscount(id, item) {
        if(!id) throw new Error('id must be required');
        // const { source } = this.state;
        // const sourcePath = source ? source : 'nasapay'; 
        this.setState({
            couponId: id
        })
        if(item) { // 选择使用优惠券
            localStorage.setItem('no_use_discount', '0');
            localStorage.setItem('user_discount', JSON.stringify(item))
        } else {
            localStorage.setItem('no_use_discount', '1');
            localStorage.removeItem('user_discount')
        }
        // this.props.history.replace(`${COURSE_URL}/${sourcePath}${window.location.search}`);
        this.handleBack();
    }

    render(){
        const { discountList, completeRender, isMobile, couponId } = this.state;
        return(
            <DocumentTitle title={'选择优惠券'} >
                <React.Fragment>
                    { !completeRender &&
                        <Load />
                    }
                    { !isMobile &&
                        <div className='discount_header' >
                            <div className="btn back" onClick={ this.handleBack }></div>
                            <h3>使用优惠券</h3>
                            <div className='line'></div>
                        </div>
                    }
                    {  discountList.length === 0 && completeRender &&
                        <div className='empty_wrap'>
                            <div className={`empty ${ isMobile ? '' : 'empty_pc' }`}>
                                没有可用的优惠券
                            </div>
                        </div>
                    }
                    {discountList.length > 0 && completeRender &&
                        <div className={`discount_wrap ${ isMobile ? '' : 'pc' }`} >
                            <div className='discount_item no_use' onClick={ () => this.selectDiscount(-1) }>
                                不使用优惠券
                                <div className={`circle ${couponId === -1 ? 'active' : ''}`}></div>
                            </div>
                            { discountList.map((item, index) => {
                                return (
                                    <div
                                        key={item.id}
                                        className='discount_item can_use'
                                        onClick={ () => this.selectDiscount(item.id, item) }
                                    >
                                        <div className='money'>
                                            <div className='money_cur'>{item.couponAmount / 100 || 0}元</div>
                                            <div className='money_total'>{item.couponConditionAmount === 0 ? '无门槛使用' : `满${item.couponConditionAmount / 100 || 0}可用`}</div>
                                        </div>
                                        <div className='diccount_desc'>
                                            <div className='discount_desc_title'>{item.couponName}</div>
                                            <div className='discount_desc_time'>有效期至{parseDate(item.endTime)}</div>
                                        </div>
                                        { item.couponCourseType === 0 && <div className='platform'>全平台通用</div> }
                                        { item.couponCourseType === 1 &&
                                            <div className='platform'>
                                                { item.couponCourseInfos.length === 1 ? `购买《${item.couponCourseInfos[0].cnName}》可用` : '限定课程可以使用' }
                                            </div>
                                        }
                                        <div className={`circle ${couponId === item.id ? 'active' : ''}`}></div>
                                    </div>
                                )
                            })}
                        </div>
                    }
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default DiscountCoupon;



// WEBPACK FOOTER //
// ./src/components/experimentOrderPage/DiscountCouponPage.jsx